module.exports = __webpack_public_path__ + "img/products-fiberconnect-thumbnail.c58657f4.jpg";